export default {
  backup: 'Backup',
  logout: 'Logout',
  login: 'Login',
  save: 'Save',
  set: 'Set',
  save_all: 'Save all',
  save_changes: 'Save changes',
  cancel: 'Cancel',
  remove: 'Remove',
  reset: 'Reset',
  reject: 'Reject',
  confirm: 'Confirm',
  apply: 'Apply',
  restore: 'Restore',
  action: 'Action',
  add_model: 'Add model',
  load: 'Load',
  update: 'Update',
  acknowledge: 'Acknowledge',
  add: {
    title: 'Add',
    preprocessor: 'Add new pre-processor',
    postprocessor: 'Add new post-processor',
    server: 'Add server',
    list: 'Add list',
    member: 'Add member',
    stream: 'Add input',
    output: 'Add output',
    user: 'Add new user',
    filter: 'Add filter',
    toDashboard: 'Add to dashboard',
    new: 'Add new',
    noResultsFor: 'No results for',
    changeSource: 'Change source',
    addToPipeline: 'Add to pipeline'
  },
  upload: {
    title: 'Upload',
    zip: 'Upload .zip',
    file: 'Drop your {types} file here or click to upload'
  },
  download: {
    log: 'Download log files'
  },
  delete: {
    log: 'Remove logs'
  },
  draw: {
    title: 'Draw',
    line: 'Line',
    rectangle: 'Rectangle',
    polygon: 'Polygon'
  }
}
